import { render } from "./MonthlyActivityPage.vue?vue&type=template&id=6ae8e6d2&scoped=true"
import script from "./MonthlyActivityPage.vue?vue&type=script&lang=js"
export * from "./MonthlyActivityPage.vue?vue&type=script&lang=js"

import "./MonthlyActivityPage.vue?vue&type=style&index=0&id=6ae8e6d2&scoped=true&lang=less"

import exportComponent from "/home/digital_profile_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae8e6d2"]])

export default __exports__